import 'reflect-metadata'
import React, { FC, Suspense } from 'react'
import { Spinner } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@rw1/shared-lib'
import { Provider as DependencyProvider } from 'inversify-react'
import { setupLocalization } from './localization'
import { Main } from './screens'
import { container } from './dependencyInjection'
import './app.css'
const queryClient = new QueryClient()

export const WebPageWrapper: FC<{ children?: React.ReactNode }> = ({ children }) => {
  void setupLocalization()

  return (
    <DependencyProvider container={container}>
      <Suspense fallback={<Spinner size="xl" />}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider
            bodyType="contained"
            themeConfig={{ initialColorMode: 'light' }}>
            {children}
          </ThemeProvider>
        </QueryClientProvider>
      </Suspense>
    </DependencyProvider>
  )
}

export const App: FC = () => <WebPageWrapper><Main /></WebPageWrapper>
